/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=32ef20d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32ef20d4&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=32ef20d4&lang=less"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ef20d4"]])

export default __exports__